<div class="qa-mfa card qa-perm-card">
  <div class="card-body">
    <!-- header: what 2FA is and the current state -->
    <div class="qa-mfa-head">
      <span class="qa-mfa-icon" [class.qa-mfa-icon-on]="user?.mfaEnabled" aria-hidden="true">
        <i class="fa" [ngClass]="user?.mfaEnabled ? 'fa-shield' : 'fa-lock'"></i>
      </span>
      <div class="qa-mfa-head-text">
        <h3>{{_(KEYS.TWO_FA.TITLE)}}</h3>
        <p>{{_(KEYS.TWO_FA.INFO)}}</p>
      </div>
      <span class="qa-mfa-status" [class.qa-mfa-status-on]="user?.mfaEnabled">
        <i class="fa" [ngClass]="user?.mfaEnabled ? 'fa-check' : 'fa-circle-o'" aria-hidden="true"></i>
        {{user?.mfaEnabled ? _(KEYS.TWO_FA.STATUS_ENABLED) : _(KEYS.TWO_FA.STATUS_DISABLED)}}
      </span>
    </div>

    <!-- not enabled: the three steps and the start button -->
    <div *ngIf="!user?.mfaEnabled && !mfaSetup" class="qa-mfa-section">
      <ol class="qa-mfa-steps">
        <li><span>1</span>{{_(KEYS.TWO_FA.BTN_SETUP)}}</li>
        <li><span>2</span>{{_(KEYS.TWO_FA.STEP_SCAN)}}</li>
        <li><span>3</span>{{_(KEYS.TWO_FA.STEP_CODE)}}</li>
      </ol>
      <button type="button" class="btn btn-primary" (click)="initiateMfa()">
        <i class="fa fa-play" aria-hidden="true"></i> {{_(KEYS.TWO_FA.BTN_SETUP)}}
      </button>
    </div>

    <!-- setup: scan the qr code (or enter the key manually), then confirm with a code -->
    <div *ngIf="mfaSetup" class="qa-mfa-section qa-mfa-setup">
      <div class="qa-mfa-pane">
        <div class="qa-mfa-pane-title"><span>2</span>{{_(KEYS.TWO_FA.STEP_SCAN)}}</div>
        <div class="qa-mfa-scan">
          <div class="qa-mfa-qr">
            <qrcode [qrdata]="mfaSetup.otpauthUrl" [margin]="0" [width]="160" [errorCorrectionLevel]="'M'"></qrcode>
          </div>
          <div class="qa-mfa-manual">
            <div class="qa-mfa-account">{{mfaSetup.issuer}} · {{mfaSetup.username}}</div>
            <div class="qa-mfa-label">{{_(KEYS.TWO_FA.MANUAL_HINT)}}</div>
            <code class="qa-mfa-secret" [attr.title]="_(KEYS.TWO_FA.LABEL_SECRET)">{{secretGroups}}</code>
            <div class="qa-mfa-meta">{{_(KEYS.TWO_FA.LABEL_DIGITS_PERIOD, {digits: mfaSetup.digits, period: mfaSetup.period})}}</div>
          </div>
        </div>
      </div>

      <form class="qa-mfa-pane" (ngSubmit)="verifyMfa()">
        <div class="qa-mfa-pane-title"><span>3</span>{{_(KEYS.TWO_FA.STEP_CODE)}}</div>
        <div class="qa-mfa-code-row">
          <input class="form-control qa-mfa-code" [placeholder]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)" [(ngModel)]="mfaCode" name="mfaCode"
                 inputmode="numeric" autocomplete="one-time-code" [attr.maxlength]="mfaSetup.digits || 6" [attr.aria-label]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)">
          <button type="submit" class="btn btn-primary" [disabled]="!mfaCode">
            <i class="fa fa-check" aria-hidden="true"></i> {{_(KEYS.TWO_FA.BTN_ENABLE)}}
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="cancelSetup()">{{_(KEYS.TWO_FA.BTN_CANCEL)}}</button>
        </div>
      </form>
    </div>

    <!-- enabled: what it means and how to switch it off -->
    <div *ngIf="user?.mfaEnabled" class="qa-mfa-section">
      <p class="qa-mfa-enabled-info"><i class="fa fa-info-circle" aria-hidden="true"></i> {{_(KEYS.TWO_FA.ENABLED_INFO)}}</p>
      <form class="qa-mfa-pane qa-mfa-disable" (ngSubmit)="disableMfaSelf()">
        <div class="qa-mfa-pane-title">{{_(KEYS.TWO_FA.BTN_DISABLE)}}</div>
        <p class="qa-mfa-label">{{_(KEYS.TWO_FA.DISABLE_HINT)}}</p>
        <div class="qa-mfa-code-row">
          <input class="form-control qa-mfa-code" [placeholder]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)" [(ngModel)]="mfaDisableCode" name="mfaDisableCode"
                 inputmode="numeric" autocomplete="one-time-code" maxlength="8" [attr.aria-label]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)">
          <button type="submit" class="btn btn-outline-danger" [disabled]="!mfaDisableCode">
            <i class="fa fa-power-off" aria-hidden="true"></i> {{_(KEYS.TWO_FA.BTN_DISABLE)}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
